// FerrumIQ Pricing Engine
// Pure functions — no Supabase imports. Takes DB-loaded config as params.

// ─── ZIP → MARKET TIER ───────────────────────────────────────────────────────
const MAJOR = new Set([100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,900,901,902,903,904,905,906,907,908,910,911,912,913,914,915,916,917,918,919,920,921,922,923,924,925,926,927,928,600,601,602,603,604,605,606,607,608,750,751,752,753,754,755,756,757,758,759,760,761,762,763,764,765,766,767,770,771,772,773,774,775,776,777,200,201,202,203,204,205,206,207,208,209,190,191,192,193,194,195,196,197,198,199,330,331,332,333,334,300,301,302,303,304,305,306,307,308,309,310,311,312,313,314,315,316,317,318,319,20,21,22,23,24,25,26,27,28,29,980,981,982,983,984,985,986,987,988,989,850,851,852,853,854,855,856,857,858,859,860,861,862,863,864,865,940,941,942,943,944,945,946,947,948,949,950,951,952,953,954,955,956,957,958,959,800,801,802,803,804,805,806,807,808,809,810,811,812,813,814,815,816,480,481,482,483,484,485,486,487,488,489,550,551,552,553,554,555,210,211,212,213,214,215,216,217,218,219,630,631,632,633,634,635,636,637,638,639,970,971,972,973,974,975,976,977,978,979,889,890,891,892,893,894,895,335,336,337,338,327,328,329,150,151,152,153,154,155,156,157,158,159,160,161,162,163,164,165,166,167,168,450,451,452,453,454,455,456,457,458,640,641,642,643,644,645,646,647,648,649,460,461,462,463,464,465,466,467,468,469,430,431,432,433,434,435,436,437,438,439,440,441,442,443,444,445,446,447,448,449,780,781,782,783,784,785,786,787,788,789,280,281,282,283,284,285,286,287,288,289,370,371,372,373,374,375,376,320,321,322,323,324,325,326,230,231,232,233,234,235,236,237,238,239,275,276,277,278,279,60,61,62,63,64,65,66,67,68,69,700,701,702,703,704,840,841,842,843,844,845,846,847,380,381,382,383,384,385,386,387,388,389,400,401,402,403,404,405,406,407,408,409]);
const MID  = new Set([740,741,742,743,744,745,746,747,748,749,350,351,352,353,354,355,356,357,358,359,870,871,872,873,874,875,876,877,878,879,880,881,882,883,884,885,795,796,797,798,799,680,681,682,683,684,685,686,687,688,689,500,501,502,503,504,505,506,507,508,509,510,511,512,513,514,515,516,517,518,519,520,720,721,722,723,724,725,726,727,728,729,490,491,492,493,494,495,496,497,498,499,707,708,710,711,712,713,714,290,291,292,293,294,295,296,297,298,299,990,991,992,993,994,836,837,838,839,535,536,537,538,539,377,378,379,670,671,672,673,674,675,676,677,678,679,936,937,932,933,934,935,130,131,132,133,134,135,136,137,138,139,14,15,16,17,18,19,120,121,122,123,124,125,126,127,128,129,655,656,657,658,659,488,489,283,284,285,930,931,184,185,186,187,188,189,339,170,171,172,173,174,175,176,177,178,179,846,847,467,468,469,570,571,572,573,574,580,581,582,583,584,610,611,614,615,626,627,628,629,541,542,543,556,557,558,685,686,687,688,689,664,665,666,667,668,669,776,777,783,784,793,794,790,791,792,797,820,821,822,823,824,825,826,827,828,829,830,831,894,895,967,968,969,590,591,592,597,598,577,578,585,586]);
const ZIP_NAMES = {
  // New York metro
  100:"New York, NY",101:"New York, NY",102:"New York, NY",103:"Staten Island, NY",
  104:"Bronx, NY",105:"Westchester, NY",106:"Westchester, NY",107:"Westchester, NY",
  108:"Westchester, NY",109:"Westchester, NY",110:"Queens, NY",111:"Queens, NY",
  112:"Brooklyn, NY",113:"Queens, NY",114:"Queens, NY",116:"Queens, NY",
  117:"Long Island, NY",118:"Long Island, NY",119:"Long Island, NY",
  // Upstate NY
  120:"Albany, NY",121:"Albany, NY",122:"Albany, NY",130:"Syracuse, NY",
  131:"Syracuse, NY",132:"Syracuse, NY",140:"Buffalo, NY",141:"Buffalo, NY",
  142:"Buffalo, NY",144:"Rochester, NY",145:"Rochester, NY",
  // PA
  150:"Pittsburgh, PA",151:"Pittsburgh, PA",152:"Pittsburgh, PA",
  170:"Harrisburg, PA",171:"Harrisburg, PA",172:"Harrisburg, PA",
  184:"Scranton, PA",185:"Scranton, PA",
  190:"Philadelphia, PA",191:"Philadelphia, PA",192:"Philadelphia, PA",
  // DC/MD/VA
  200:"Washington, DC",201:"Washington, DC",202:"Washington, DC",
  203:"Washington, DC",204:"Washington, DC",205:"Washington, DC",
  210:"Baltimore, MD",211:"Baltimore, MD",212:"Baltimore, MD",
  220:"Northern Virginia",221:"Northern Virginia",222:"Northern Virginia",
  230:"Hampton Roads, VA",231:"Richmond, VA",232:"Richmond, VA",
  // NJ
  70:"Newark, NJ",71:"Newark, NJ",72:"Trenton, NJ",73:"Trenton, NJ",
  74:"Elizabeth, NJ",75:"Princeton, NJ",76:"Atlantic City, NJ",
  77:"Long Branch, NJ",78:"Freehold, NJ",79:"New Brunswick, NJ",
  // CT — use 3-digit to avoid collision with Chicago 60x
  60:"Hartford, CT",
  // MA/RI
  20:"Boston, MA",21:"Boston, MA",22:"Boston, MA",23:"Boston, MA",
  24:"Boston, MA",25:"Cape Cod, MA",26:"Worcester, MA",27:"Worcester, MA",
  28:"Providence, RI",29:"Providence, RI",
  // NC
  275:"Raleigh, NC",276:"Raleigh, NC",277:"Raleigh, NC",
  280:"Charlotte, NC",281:"Charlotte, NC",282:"Charlotte, NC",
  // SC
  290:"Columbia, SC",291:"Columbia, SC",293:"Greenville, SC",295:"Greenville, SC",
  // GA
  300:"Atlanta, GA",301:"Atlanta, GA",302:"Atlanta, GA",303:"Atlanta, GA",
  // FL
  320:"Jacksonville, FL",321:"Daytona Beach, FL",322:"Jacksonville, FL",
  323:"Tallahassee, FL",325:"Pensacola, FL",
  327:"Orlando, FL",328:"Orlando, FL",329:"Orlando, FL",
  330:"Miami, FL",331:"Miami, FL",332:"Miami, FL",333:"Fort Lauderdale, FL",334:"West Palm Beach, FL",
  335:"Tampa, FL",336:"Tampa, FL",337:"St. Petersburg, FL",338:"Lakeland, FL",
  339:"Fort Myers, FL",
  // AL
  350:"Birmingham, AL",351:"Birmingham, AL",352:"Birmingham, AL",357:"Huntsville, AL",
  // TN
  370:"Nashville, TN",371:"Nashville, TN",372:"Nashville, TN",
  373:"Chattanooga, TN",374:"Chattanooga, TN",
  377:"Knoxville, TN",378:"Knoxville, TN",
  380:"Memphis, TN",381:"Memphis, TN",
  // KY
  400:"Louisville, KY",401:"Louisville, KY",402:"Louisville, KY",
  // OH
  430:"Columbus, OH",431:"Columbus, OH",432:"Columbus, OH",
  440:"Cleveland, OH",441:"Cleveland, OH",442:"Cleveland, OH",443:"Akron, OH",444:"Youngstown, OH",
  450:"Cincinnati, OH",451:"Cincinnati, OH",452:"Cincinnati, OH",
  453:"Dayton, OH",454:"Dayton, OH",
  // IN
  460:"Indianapolis, IN",461:"Indianapolis, IN",462:"Indianapolis, IN",
  467:"Fort Wayne, IN",468:"Fort Wayne, IN",
  // MI
  480:"Detroit, MI",481:"Detroit, MI",482:"Detroit, MI",483:"Ann Arbor, MI",
  484:"Flint, MI",485:"Flint, MI",
  490:"Grand Rapids, MI",491:"Grand Rapids, MI",
  // IA
  500:"Des Moines, IA",501:"Des Moines, IA",502:"Des Moines, IA",
  // MN
  550:"Minneapolis, MN",551:"Minneapolis, MN",552:"Minneapolis, MN",
  553:"Minneapolis, MN",554:"Minneapolis, MN",555:"Minneapolis, MN",
  // IL — all Chicago metro prefixes 600-608
  600:"Chicago, IL",601:"Chicago suburbs, IL",602:"Chicago suburbs, IL",
  603:"Chicago suburbs, IL",604:"Chicago suburbs, IL",605:"Chicago suburbs, IL",
  606:"Chicago, IL",607:"Chicago suburbs, IL",608:"Chicago suburbs, IL",
  610:"Rockford, IL",611:"Rockford, IL",614:"Peoria, IL",615:"Peoria, IL",
  616:"Peoria, IL",620:"Springfield, IL",622:"Springfield, IL",
  626:"Springfield, IL",627:"Springfield, IL",
  // MO
  630:"St. Louis, MO",631:"St. Louis, MO",632:"St. Louis, MO",
  633:"St. Louis, MO",634:"St. Louis, MO",
  640:"Kansas City, MO",641:"Kansas City, MO",
  655:"Springfield, MO",656:"Springfield, MO",
  // KS
  660:"Wichita, KS",661:"Wichita, KS",662:"Wichita, KS",
  670:"Wichita, KS",671:"Wichita, KS",
  // NE
  680:"Omaha, NE",681:"Omaha, NE",685:"Lincoln, NE",
  // LA
  700:"New Orleans, LA",701:"New Orleans, LA",
  707:"Baton Rouge, LA",708:"Baton Rouge, LA",
  710:"Shreveport, LA",711:"Shreveport, LA",
  // AR
  720:"Little Rock, AR",721:"Little Rock, AR",722:"Little Rock, AR",
  // OK
  730:"Oklahoma City, OK",731:"Oklahoma City, OK",
  740:"Tulsa, OK",741:"Tulsa, OK",
  // TX
  750:"Dallas, TX",751:"Dallas, TX",752:"Dallas, TX",
  753:"Dallas, TX",754:"Dallas, TX",
  760:"Fort Worth, TX",761:"Fort Worth, TX",762:"Fort Worth, TX",
  770:"Houston, TX",771:"Houston, TX",772:"Houston, TX",
  773:"Houston, TX",774:"Houston, TX",
  775:"Houston, TX",776:"Houston, TX",777:"Beaumont, TX",
  780:"San Antonio, TX",781:"San Antonio, TX",782:"San Antonio, TX",
  783:"Corpus Christi, TX",784:"Corpus Christi, TX",
  786:"Austin, TX",787:"Austin, TX",788:"Austin, TX",
  793:"Lubbock, TX",794:"Lubbock, TX",
  795:"El Paso, TX",796:"El Paso, TX",797:"El Paso, TX",
  // CO
  800:"Denver, CO",801:"Denver, CO",802:"Denver, CO",
  803:"Denver, CO",804:"Denver, CO",
  808:"Colorado Springs, CO",809:"Colorado Springs, CO",
  // ID
  836:"Boise, ID",837:"Boise, ID",838:"Boise, ID",
  // UT
  840:"Salt Lake City, UT",841:"Salt Lake City, UT",842:"Salt Lake City, UT",
  843:"Ogden, UT",844:"Ogden, UT",846:"Provo, UT",847:"Provo, UT",
  // AZ
  850:"Phoenix, AZ",851:"Phoenix, AZ",852:"Scottsdale, AZ",
  853:"Mesa, AZ",854:"Mesa, AZ",855:"Phoenix, AZ",
  856:"Tucson, AZ",857:"Tucson, AZ",
  // NM
  870:"Albuquerque, NM",871:"Albuquerque, NM",872:"Albuquerque, NM",
  // NV
  889:"Las Vegas, NV",890:"Las Vegas, NV",891:"Las Vegas, NV",
  892:"Las Vegas, NV",893:"Las Vegas, NV",894:"Reno, NV",895:"Reno, NV",
  // CA
  900:"Los Angeles, CA",901:"Los Angeles, CA",902:"Los Angeles, CA",
  903:"Los Angeles, CA",904:"Los Angeles, CA",905:"Los Angeles, CA",
  906:"Los Angeles, CA",907:"Los Angeles, CA",908:"Los Angeles, CA",
  910:"Pasadena, CA",911:"Pasadena, CA",912:"Los Angeles, CA",
  913:"Los Angeles, CA",914:"Van Nuys, CA",915:"Burbank, CA",
  916:"North Hollywood, CA",917:"Woodland Hills, CA",918:"Thousand Oaks, CA",
  919:"San Diego, CA",920:"San Diego, CA",921:"San Diego, CA",
  922:"San Diego, CA",923:"San Diego, CA",924:"San Diego, CA",
  925:"San Jose, CA",926:"Santa Ana, CA",927:"Anaheim, CA",928:"Riverside, CA",
  930:"Oxnard, CA",931:"Santa Barbara, CA",932:"Bakersfield, CA",933:"Bakersfield, CA",
  936:"Fresno, CA",937:"Fresno, CA",
  940:"San Francisco, CA",941:"San Francisco, CA",942:"Sacramento, CA",
  943:"San Jose, CA",944:"San Mateo, CA",945:"Oakland, CA",946:"Oakland, CA",
  947:"Berkeley, CA",948:"Richmond, CA",949:"San Jose, CA",950:"San Jose, CA",
  951:"San Jose, CA",952:"Stockton, CA",953:"Modesto, CA",
  954:"Santa Rosa, CA",955:"Eureka, CA",956:"Sacramento, CA",957:"Sacramento, CA",
  958:"Sacramento, CA",959:"Sacramento, CA",
  // HI
  967:"Honolulu, HI",968:"Honolulu, HI",
  // OR
  970:"Portland, OR",971:"Portland, OR",972:"Portland, OR",
  973:"Salem, OR",974:"Eugene, OR",975:"Medford, OR",
  // WA
  980:"Seattle, WA",981:"Seattle, WA",982:"Tacoma, WA",983:"Tacoma, WA",
  984:"Olympia, WA",985:"Olympia, WA",
  // WY
  820:"Cheyenne, WY",821:"Cheyenne, WY",
  // SD/ND
  570:"Sioux Falls, SD",577:"Rapid City, SD",
  580:"Fargo, ND",581:"Fargo, ND",585:"Bismarck, ND",
  // WI
  530:"Milwaukee, WI",531:"Milwaukee, WI",532:"Milwaukee, WI",
  535:"Madison, WI",537:"Madison, WI",541:"Green Bay, WI",
  // Spokane/AK
  990:"Spokane, WA",991:"Spokane, WA",995:"Anchorage, AK",
};

export function lookupZip(raw) {
  const z = raw.replace(/\D/g, '').slice(0, 5);
  if (z.length < 3) return null;
  const p3 = parseInt(z.slice(0, 3), 10);
  const p2 = parseInt(z.slice(0, 2), 10);
  const tier = MAJOR.has(p3) || MAJOR.has(p2) ? 'major_metro'
    : MID.has(p3) || MID.has(p2) ? 'mid_market' : 'small_market';
  return { tier, name: ZIP_NAMES[p3] || ZIP_NAMES[p2] || null, zip: z };
}

// ─── MULTIPLIER TABLES (legacy hardcoded) ────────────────────────────────────
// COV_M stays hardcoded — coverage tier (8x5 / 24x5 / 24x7) is a structural
// product offering, not a per-deal pricing tunable.
const COV_M  = { business_hours: 1.0, '24x5': 1.2, '24x7': 1.35 };

// v3.5.58: RISK_M removed entirely. Industry Risk no longer applies a hidden
// labor multiplier — it now drives the visible ITSO Advisory line (see
// getItsoUpliftRate / itsoMRR computation in calcQuote / calcLocationMRR).
//
// COMP_M and CPLX_M moved to settings-driven helpers below. The hardcoded
// objects remain as fallback defaults if a pricing_settings row is missing,
// preserving prior behavior on a pristine DB.

// ─── Settings-driven helpers (v3.5.58) ───────────────────────────────────────
// Read pricing tunables from pricing_settings with sane defaults. Centralizes
// the previously-duplicated `parseFloat(s.X) || N` pattern and adds the
// senior-rate distinction needed for ITSO hour derivation.

// v3.5.59: Compliance moved to product-driven model (see Compliance category
// add-on products: HIPAA Compliance Program, SOC 2 Continuous Monitoring, etc.).
// Default multipliers neutralized to 1.0 across all keys — admin can still
// re-enable percentage uplifts via pricing_settings.compliance_mult_<key> if
// desired, but the recommended pattern is to add the matching Compliance
// product instead so reps see line-item deliverables on the quote.
// Five framework keys (hipaa, soc2, pci, cmmc) plus 'none' for the new
// dropdown; legacy 'moderate'/'high' keys retained at 1.0 to avoid surprising
// behavior on any test quote that still has those values.
const COMP_M_DEFAULTS = { none: 1.0, hipaa: 1.0, soc2: 1.0, pci: 1.0, cmmc: 1.0, moderate: 1.0, high: 1.0 };
const CPLX_M_DEFAULTS = { low: 1.0, medium: 1.08, high: 1.18 };

// ITSO Advisory uplift defaults (Industry Risk-driven). Customer-facing values:
// None = 0%, Low = 10%, Medium = 15%, High = 20%. SQL migration seeds these.
const ITSO_RATE_DEFAULTS = { none: 0.00, low: 0.10, medium: 0.15, high: 0.20 };

// Tier label defaults — admin-overridable for branding/marketing copy.
const ITSO_LABEL_DEFAULTS = {
  low:    'ITSO Advisory — Standard',
  medium: 'ITSO Advisory — Enhanced',
  high:   'ITSO Advisory — Premium',
};

/**
 * Blended labor burden rate. Used for package labor (hrs_user / hrs_ws / etc.),
 * flex time, and any other "delivery hours" cost calculation across all five
 * quote types. NOT used for ITSO/vCIO advisory hours (use getSeniorBurdenedRate
 * for those). Reads pricing_settings.burdened_hourly_rate; falls back to 80
 * (the tuned-down default that matches FerrumIT's actual blended cost as of
 * v3.5.58 — was previously 125 in fallbacks across 13 sites).
 */
export function getBurdenedRate(settings) {
  return parseFloat(settings?.burdened_hourly_rate) || 80;
}

/**
 * Senior staff burden rate. Used to derive vCIO / ITSO advisory hours from
 * the ITSO line revenue: itsoHours = itsoMRR / getSeniorBurdenedRate(s).
 * Senior staff (vCIO, principal engineer) cost more than the blended rate,
 * so accounting for ITSO at the blended rate would understate true cost.
 * Reads pricing_settings.senior_burdened_hourly_rate; falls back to 110.
 */
export function getSeniorBurdenedRate(settings) {
  return parseFloat(settings?.senior_burdened_hourly_rate) || 110;
}

/**
 * v3.5.74: ITSO Advisory billable rate. The rate clients are charged per
 * senior-advisory hour delivered. Used to derive the hours-delivered figure
 * from the ITSO line revenue (itsoHours = itsoMRR ÷ billable rate). Distinct
 * from getSeniorBurdenedRate above, which is what Ferrum PAYS for senior
 * staff time — billable is what's CHARGED. This split converts the ITSO
 * Advisory line from zero-margin (Option B, retired in v3.5.74) to a normal
 * positive-margin advisory service (Option B-prime). At the seeded defaults
 * — billable $200/hr, senior burden $110/hr — the ITSO line carries ~45%
 * gross margin per hour delivered, in line with industry advisory norms.
 *
 * NOTE on the 1.75× tier-3 base concept: a separate billable rate scheme
 * may exist elsewhere in the codebase computing tier-3 billable as
 * 1.75 × $80 base = $140. That's distinct from this $200 ITSO-specific
 * billable. The two may need reconciliation later — for now this setting
 * is ITSO-Advisory-only and does not feed into other rate-card surfaces.
 *
 * Reads pricing_settings.itso_billable_rate; falls back to 200.
 */
export function getItsoBillableRate(settings) {
  return parseFloat(settings?.itso_billable_rate) || 200;
}

/**
 * Compliance multiplier — applied to discountable subtotal as part of compMult.
 * Reads pricing_settings.compliance_mult_<key> (none / moderate / high);
 * falls back to legacy hardcoded values (1.00 / 1.12 / 1.22).
 */
export function getComplianceMultiplier(settings, complianceKey) {
  const k = complianceKey || 'none';
  const v = parseFloat(settings?.[`compliance_mult_${k}`]);
  return Number.isFinite(v) && v > 0 ? v : (COMP_M_DEFAULTS[k] || 1);
}

/**
 * Complexity multiplier — applied to discountable subtotal as part of compMult.
 * Reads pricing_settings.complexity_mult_<key> (low / medium / high);
 * falls back to legacy hardcoded values (1.00 / 1.08 / 1.18).
 */
export function getComplexityMultiplier(settings, complexityKey) {
  const k = complexityKey || 'low';
  const v = parseFloat(settings?.[`complexity_mult_${k}`]);
  return Number.isFinite(v) && v > 0 ? v : (CPLX_M_DEFAULTS[k] || 1);
}

/**
 * ITSO Advisory uplift rate — driven by Industry Risk tier. Returns a fraction
 * (e.g. 0.20 for High Risk) that gets multiplied against the labor base
 * (itSubtotal × compMult, excluding addons & flex) to produce the ITSO line.
 * Reads pricing_settings.itso_risk_uplift_<key> (none / low / medium / high);
 * falls back to seeded defaults if missing.
 */
export function getItsoUpliftRate(settings, industryRiskKey) {
  const k = industryRiskKey || 'none';
  const v = parseFloat(settings?.[`itso_risk_uplift_${k}`]);
  return Number.isFinite(v) && v >= 0 ? v : (ITSO_RATE_DEFAULTS[k] || 0);
}

/**
 * Display label for the ITSO Advisory line. Per-tier strings are
 * admin-editable so marketing/sales can rename tiers without a deploy.
 * Returns null when uplift rate is 0 (no line should render).
 */
export function getItsoLabel(settings, industryRiskKey) {
  const rate = getItsoUpliftRate(settings, industryRiskKey);
  if (rate === 0) return null;
  const k = industryRiskKey || 'low';
  return settings?.[`itso_label_${k}`] || ITSO_LABEL_DEFAULTS[k] || 'ITSO Advisory';
}

// ─── Contract term dropdown options (v3.5.86.2.1) ─────────────────────────────
// Returns the options array used by Contract Term dropdowns on QuotePage and
// MultiSiteQuotePage. Each option is `[String(term), label]` matching the
// existing `<SI>` / `opts` shape, where the label includes the discount
// percentage read from `pricing_settings.contract_disc_${term}` — the SAME
// settings key that the calc engine reads at line ~601 below (and that
// MultiSiteQuotePage reads at its line ~273).
//
// Why this exists: prior to v3.5.86.2.1 the dropdown labels were hardcoded as
// `'12 mo (5%)' / '24 mo (10%)' / '36 mo (20%)'`, which silently went stale
// when an admin changed the percentage in pricing_settings. The calc kept
// using the new percentage; the dropdown kept showing the old one. Reps saw
// inconsistent numbers between picker and totals.
//
// Behavior:
//   - terms defaults to [12, 24, 36] (the business-blessed term list); pass
//     a different array if you need a non-standard set
//   - If contract_disc_${term} is 0 or missing, the label omits the
//     parenthetical entirely (e.g. just "12 mo") — keeps the dropdown
//     readable when an admin zeroes out a discount
//   - Settings values are stored as decimal fractions (0.10 = 10%)
//
// Voice intentionally does NOT use this — the voice pricing engine doesn't
// apply contract_disc_* to voice MRR, so showing a percentage there would
// mislead reps. Bundle's voice-side discount tiers (5/10/15% off voice MRR)
// come from calcBundleDiscount in voicePricing.js, which is a separate
// hardcoded thing on the punch list.
export function getContractTermOptions(settings, terms = [12, 24, 36]) {
  return terms.map(term => {
    const rate = parseFloat(settings?.[`contract_disc_${term}`]) || 0;
    const pct  = Math.round(rate * 100);
    const label = pct > 0 ? `${term} mo (${pct}%)` : `${term} mo`;
    return [String(term), label];
  });
}

// ─── Cost components helper (v3.5.41) ────────────────────────────────────────
// Computes tooling cost from a list of package_cost_components rows. Mirrors
// the per-driver math in the legacy aggregate path but reads cost from each
// component's product (cost_price) and scales by qty_driver / qty_per_unit /
// min_qty.
//
// Returns:
//   { total: number, tools: Array<{ name, qty_driver, qty, rate, total, internal_only }> }
//
// Driver lookups by name — supports nine qty_drivers in the schema (v3.5.96.0):
// workstations, users, servers, locations, cloud_tenants, endpoints,
// mobile_devices, domains, flat. 'flat' uses qty_per_unit as the constant
// per-quote quantity (e.g. 1.0 for a single $100/mo Hudu license per quote).
function calcToolingFromComponents(components, inputs) {
  if (!components || components.length === 0) return { total: 0, tools: [] };
  // Map qty_driver to inputs[…] value. cloud_tenants in DB → cloudTenants in JS.
  const driverValue = (driver) => {
    switch (driver) {
      case 'workstations':   return parseInt(inputs.workstations) || 0;
      case 'users':          return parseInt(inputs.users)        || 0;
      case 'servers':        return parseInt(inputs.servers)      || 0;
      case 'locations':      return parseInt(inputs.locations)    || 0;
      case 'cloud_tenants':  return parseInt(inputs.cloudTenants) || 0;
      case 'endpoints':      return parseInt(inputs.endpoints)    || 0;
      case 'mobile_devices': return parseInt(inputs.mobileDevices) || 0;
      // v3.5.96.0: domains added as a new infrastructure qty driver alongside
      // the existing eight. For Managed IT and Bundle, inputs.domains is a
      // single quote-level integer. For MultiSite, the engine sums per-
      // location l.domains into inputs.domains before calling this function
      // (or, when this function is called per-location via calcLocationMRR,
      // l.domains is already in scope). Default 0 if absent on legacy quotes
      // saved before v3.5.96.0 — they get no domain-driven cost contribution
      // unless re-saved with a non-zero value.
      case 'domains':        return parseInt(inputs.domains)      || 0;
      case 'flat':           return 1; // qty_per_unit becomes the quantity directly
      default: return 0;
    }
  };

  let total = 0;
  const tools = [];
  for (const c of components) {
    const driver = c.qty_driver;
    const perUnit = parseFloat(c.qty_per_unit) || 1.0;
    const minQty = parseInt(c.min_qty) || 0;
    const rawQty = driver === 'flat' ? perUnit : (driverValue(driver) * perUnit);
    const qty = Math.max(minQty, rawQty);
    const rate = Number(c.cost_price) || 0;
    const lineTotal = qty * rate;
    total += lineTotal;
    tools.push({
      name:           c.product_name || 'Unknown tool',
      qty_driver:     driver,
      qty,
      rate,
      total:          lineTotal,
      internal_only:  !!c.internal_only,
    });
  }
  return { total, tools };
}

// ─── MAIN CALC ───────────────────────────────────────────────────────────────
// `packageIncludes` (added v3.5.31): array of resolved package_includes rows,
//   each shaped like { id, product_id, is_mandatory, sort_order, notes,
//                      product_name, sell_price, cost_price, qty_driver,
//                      cost_qty_driver, no_discount, no_commission }
//   When omitted or empty, no include processing happens (legacy behavior).
// `excludedIncludes` (added v3.5.31): array of include IDs the rep unchecked
//   (only swappable includes can be excluded; rep-side UI enforces that).
// `costComponents` (added v3.5.41, became sole tooling path in v3.5.57): array
//   of resolved package_cost_components rows, each shaped per
//   loadPackageCostComponents return type. The engine computes toolingCost
//   from these unconditionally. Empty array → toolingCost is 0 (correct:
//   no stack = no cost). Caller is responsible for resolving components for
//   the package and passing them in.
export function calcQuote({ inputs, pkg, marketTier, products, settings, aiMultiplierOverride, repCommissionRate, snapshot, packageIncludes, excludedIncludes, includeSwaps, costComponents }) {
  // If a pricing snapshot exists, use frozen rates instead of live data
  if (snapshot) {
    pkg              = snapshot.package          || pkg;
    products         = snapshot.products         || products;
    settings         = snapshot.settings         || settings;
    packageIncludes  = snapshot.packageIncludes  || packageIncludes;
    if (snapshot.includeSwaps !== undefined) includeSwaps = snapshot.includeSwaps;
  }
  if (!pkg || !marketTier || !settings) return null;

  const s = settings; // shorthand — settings is a key→value map
  // v3.5.38: Market Intelligence is now the SOLE source of pricing adjustment.
  // The static marketTier.labor_multiplier column was dropped — tiers remain
  // as classification tags only. If aiMultiplierOverride is provided (set by
  // accepted Market Intelligence analysis), it's applied. Otherwise no
  // adjustment is made (effectively 1.00×). The marketTier param is still
  // required in the signature so existing call sites don't break and so
  // tier_key is still available for snapshot/display purposes.
  const mktMult = aiMultiplierOverride != null ? aiMultiplierOverride : 1;

  // ── Managed IT base — market multiplier applied to sell rates ────────────
  const wB  = inputs.workstations * pkg.ws_rate    * mktMult;
  const uB  = inputs.users        * pkg.user_rate  * mktMult;
  const sB  = inputs.servers      * pkg.server_rate * mktMult;
  const lB  = inputs.locations    * pkg.location_rate * mktMult;
  const tB  = inputs.cloudTenants * pkg.tenant_rate * mktMult;
  const xv  = Math.max(inputs.vendors - pkg.included_vendors, 0);
  const vB  = xv * pkg.vendor_rate * mktMult;

  const epRatio = inputs.workstations > 0 ? inputs.endpoints / inputs.workstations : 0;
  const xEp = Math.max(inputs.endpoints - inputs.workstations * 1.25, 0);
  // v3.5.61: Log Storage & SIEM Uplift (was "Endpoint density uplift").
  // The math is unchanged — bracket the rate at ratio = 1.75. The change here
  // is the `|| 0` fallback (parity with calcLocationMRR — without it, a missing
  // pricing_settings row produces NaN that cascades into itSubtotal) and the
  // explicit epTier so quote pages can render the math inline.
  const epTier = epRatio <= 1.75 ? 'moderate' : 'high';
  const epRate = epTier === 'moderate'
    ? parseFloat(s.ep_uplift_moderate) || 0
    : parseFloat(s.ep_uplift_high)     || 0;
  const eB = xEp * epRate;

  const reqCovMult = COV_M[inputs.requestedCoverage] || 1;
  const pkgCovMult = COV_M[pkg.coverage] || 1;
  const covU = Math.max(reqCovMult / pkgCovMult - 1, 0) * wB;

  const itSubtotal = wB + uB + sB + lB + tB + vB + eB + covU;

  // ── Selected add-on products + swap substitutes (v3.5.33) ─────────────────
  // Swap substitutes are products the rep selected to replace a swappable
  // include. They behave exactly like normal paid add-ons (full sell, full cost,
  // participate in commission/discount math) — the only difference is they're
  // tagged with swap_from_include_id and the original include's cost is
  // separately removed from totalCost (handled in the includes loop below).
  const lineItems = [];
  let discountableAddonRevenue   = 0;  // products eligible for contract discount
  let protectedAddonRevenue      = 0;  // MSRP products — never discounted
  let nonCommissionAddonRevenue  = 0;  // products excluded from commission base
  let addonCost = 0;

  // Build the unified processing list: selected add-ons + swap substitutes.
  // Each entry: { product, swapFromIncludeId? }
  const processList = [];
  for (const p of products.filter(pr => inputs.selectedProducts?.includes(pr.id))) {
    processList.push({ product: p, swapFromIncludeId: null });
  }
  // Swap substitutes — only process if the include they're replacing is also
  // in excludedSet (the invariant a rep-side UI must maintain). If a swap
  // exists for a non-excluded include, ignore it (the include is still active).
  if (includeSwaps && typeof includeSwaps === 'object') {
    const excludedSetTmp = new Set(excludedIncludes || []);
    for (const [includeId, subProductId] of Object.entries(includeSwaps)) {
      if (!excludedSetTmp.has(includeId)) continue;
      const sub = products.find(pr => pr.id === subProductId);
      if (!sub) continue;
      // Skip if the substitute is also already in selectedProducts to avoid double-counting
      if (inputs.selectedProducts?.includes(sub.id)) continue;
      processList.push({ product: sub, swapFromIncludeId: includeId });
    }
  }

  for (const { product, swapFromIncludeId } of processList) {
    const sellQty = getSellQty(product, inputs);
    const costQty = getCostQty(product, inputs);
    // v3.5.59: base_fee / base_cost support — flat MRR & COGS added on top of
    // qty × rate. Used by Compliance Program products (HIPAA / SOC 2 / PCI /
    // CMMC) where there's a fixed monthly program-management cost (BAAs,
    // policy maintenance, audit support, evidence collection) plus a small
    // per-user component for tooling/awareness. Defaults to 0 for legacy
    // products so existing math is unchanged.
    const baseFee  = Number(product.base_fee)  || 0;
    const baseCost = Number(product.base_cost) || 0;
    const revenue = sellQty * product.sell_price + baseFee;
    const cost    = costQty * product.cost_price + baseCost;

    if (product.no_discount) {
      protectedAddonRevenue += revenue;     // passes through at full MSRP
    } else {
      discountableAddonRevenue += revenue;  // eligible for contract discount
    }
    if (product.no_commission) {
      nonCommissionAddonRevenue += revenue; // excluded from commission base
    }

    addonCost += cost;
    lineItems.push({
      product_id:       product.id,
      product_name:     product.name,
      category:         product.category,
      qty_driver:       product.qty_driver,
      cost_qty_driver:  product.cost_qty_driver || null,
      qty:              sellQty,
      cost_qty:         costQty,
      sell_price:       product.sell_price,
      cost_price:       product.cost_price,
      // v3.5.59: persist base_fee/base_cost on the line item so quote snapshots
      // record the full pricing structure and per-line revenue reconciles.
      base_fee:         baseFee,
      base_cost:        baseCost,
      no_discount:      product.no_discount  || false,
      no_commission:    product.no_commission || false,
      revenue,
      cost,
      // v3.5.33: present only on substitute line items so UI can label them
      swap_from_include_id: swapFromIncludeId || undefined,
    });
  }

  const addonRevenue = discountableAddonRevenue + protectedAddonRevenue;

  // ── Package Includes (v3.5.31) ────────────────────────────────────────────
  // Products bundled into the package itself. Sell side = $0 (the package's
  // per-unit rates already cover delivery). Cost side = full COGS rolled into
  // the totalCost so margin reporting stays accurate.
  // Rep-excluded swappable includes are skipped entirely (no sell, no cost).
  const includedLineItems = [];
  let includedItemsCost = 0;
  const excludedSet = new Set(excludedIncludes || []);
  for (const inc of (packageIncludes || [])) {
    if (excludedSet.has(inc.id)) continue;
    // Use the include's snapshot of qty_driver / cost_qty_driver / cost_price
    // so quotes saved before product changes still price correctly.
    const cqDriver = inc.cost_qty_driver || inc.qty_driver;
    const sqDriver = inc.qty_driver;
    const product  = { id: inc.product_id, qty_driver: sqDriver, cost_qty_driver: cqDriver };
    const sellQty  = getSellQty(product, inputs);
    const costQty  = getCostQty(product, inputs);
    const cost     = costQty * (Number(inc.cost_price) || 0);
    includedItemsCost += cost;
    includedLineItems.push({
      include_id:      inc.id,
      product_id:      inc.product_id,
      product_name:    inc.product_name,
      category:        inc.category || null,
      is_mandatory:    !!inc.is_mandatory,
      qty_driver:      sqDriver,
      cost_qty_driver: cqDriver,
      qty:             sellQty,
      cost_qty:        costQty,
      sell_price:      0,                       // bundled — no sell line
      cost_price:      Number(inc.cost_price) || 0,
      revenue:         0,
      cost,
      sort_order:      inc.sort_order ?? 100,
    });
  }
  includedLineItems.sort((a, b) => a.sort_order - b.sort_order);

  // Excluded includes (for snapshot purposes — record what rep removed)
  const excludedIncludeIds = (packageIncludes || [])
    .filter(inc => excludedSet.has(inc.id))
    .map(inc => inc.id);

  // ── Composite multiplier (applies to labor + discountable addons only) ────
  // v3.5.58: RISK_M removed — Industry Risk now drives the ITSO line below
  // instead of stacking invisibly into compMult. compMult is now Compliance ×
  // Complexity only, both settings-driven via getCompliance/getComplexity helpers.
  const compMult = getComplianceMultiplier(s, inputs.compliance)
                 * getComplexityMultiplier(s, inputs.complexity);

  // ── ITSO Advisory line (v3.5.58, cost rebased v3.5.74) ────────────────────
  // Industry Risk drives a visible advisory uplift on the labor portion of
  // the deal. Replaces the prior hidden RISK_M multiplier (which was 1.0 /
  // 1.1 / 1.2 for low/medium/high, baked into compMult). The new line:
  //
  //   • Base = itSubtotal × compMult — the labor charges after compliance/
  //     complexity adjustments, but BEFORE addons (per "labor not products"
  //     intent) and BEFORE term discount.
  //   • Uplift % = settings-driven, per Industry Risk tier (None=0, Low=10,
  //     Medium=15, High=20 by seeded defaults).
  //   • Term discount: applies (gross value flows into discountableSubtotal
  //     below; the term discount is then applied proportionally and itsoMRR
  //     is rebased to its post-discount net value before being returned).
  //   • Commission: applies (line flows into discountedLabor → commissionBase).
  //   • Hours delivered (v3.5.74): post-discount itsoMRR ÷ ITSO billable
  //     rate (admin-editable, default $200/hr). Senior advisory hours
  //     committed per month.
  //   • Cost (v3.5.74 Option B-prime): hours × senior burdened rate
  //     ($110/hr default). Replaces the v3.5.58 Option B zero-margin model.
  //     The line now carries ~45% GM at default rates, in line with normal
  //     advisory service margins. See getItsoBillableRate() for the full
  //     architecture rationale.
  const itsoBaseMRR     = itSubtotal * compMult;
  const itsoUpliftRate  = getItsoUpliftRate(s, inputs.industryRisk);
  const itsoMRRGross    = Math.round(itsoBaseMRR * itsoUpliftRate * 100) / 100;
  const itsoLabel       = getItsoLabel(s, inputs.industryRisk);

  // Labor + discountable products get the comp/cplx multiplier.
  // ITSO (gross) is ADDED on top — gets the term discount via the floor
  // mechanism below but doesn't compound with comp/cplx.
  const discountableSubtotal = (itSubtotal + discountableAddonRevenue) * compMult + itsoMRRGross;
  // Protected products pass through untouched
  const riskAdjMRR = discountableSubtotal + protectedAddonRevenue;

  // ── Floor + discount (labor + discountable addons only) ───────────────────
  const floor    = parseFloat(s.min_commitment) || 350;
  const discKey  = `contract_disc_${inputs.contractTerm}`;
  const discRate = parseFloat(s[discKey]) || 0;
  // Discount only on the portion above the floor, and only on discountable revenue
  const discountableAboveFloor = Math.max(discountableSubtotal - floor, 0);
  const discount  = -discountableAboveFloor * discRate;
  const discountedLabor = Math.max(discountableSubtotal + discount, floor);
  const finalMRR  = discountedLabor + protectedAddonRevenue;

  // ── ITSO Advisory — post-discount net (v3.5.58, retuned v3.5.74) ──────────
  // Rebase itsoMRR to its post-discount value so the displayed line equals
  // what the customer actually pays. The discount factor is applied
  // proportionally based on how much of discountableSubtotal got discounted
  // — this handles the floor edge case correctly (small deals where the
  // floor prevents the full discount from applying).
  //
  // v3.5.74 Option B-prime: replaces the v3.5.58 Option B zero-margin model.
  //   • Hours delivered (itsoHours) = itsoMRR ÷ ITSO billable rate (admin-
  //     editable via itso_billable_rate, default $200/hr). This is the
  //     senior advisory billable rate — what the client pays per hour of
  //     senior advisory time delivered.
  //   • Cost (itsoCost) = itsoHours × senior burdened rate ($110/hr default,
  //     admin-editable via senior_burdened_hourly_rate). This is what
  //     Ferrum pays internally for senior staff time.
  //   • Margin: at default rates, $200 billable − $110 cost = $90 per hour,
  //     45% GM. The advisory line now carries a realistic margin instead of
  //     compressing to zero.
  //
  // Why the rebase: Option B (cost = revenue) was originally framed as
  // "surface previously-hidden senior staff cost." After production review,
  // that framing was reconsidered: the line still collects real revenue
  // from clients, so treating it as zero-margin overstates the advisory
  // cost burden and understates the profitability of high-risk deals. The
  // two-rate model (billable vs burden) is the standard way professional
  // services account for senior advisory time.
  const itsoDiscountFactor = discountableSubtotal > 0
    ? discountedLabor / discountableSubtotal
    : 1;
  const itsoMRR        = Math.round(itsoMRRGross * itsoDiscountFactor * 100) / 100;
  const seniorBurden   = getSeniorBurdenedRate(s);
  const itsoBillable   = getItsoBillableRate(s);
  const itsoHours      = itsoMRR > 0 && itsoBillable > 0 ? itsoMRR / itsoBillable : 0;
  const itsoCost       = Math.round(itsoHours * seniorBurden * 100) / 100;

  // ── Commission ────────────────────────────────────────────────────────────
  // Rep-level rate takes priority over global setting
  const commissionRate = repCommissionRate != null ? repCommissionRate : (parseFloat(s.commission_rate) || 0);
  // Commission base = discounted labor + commissionable addons (excludes no_commission products)
  const commissionBase  = discountedLabor + (discountableAddonRevenue - nonCommissionAddonRevenue) * (1 - discRate);
  const commission      = commissionBase * commissionRate;
  const netAfterCommission = finalMRR - commission;

  // ── Cost model ────────────────────────────────────────────────────────────
  // v3.5.57: components-only. The legacy aggregate stack_cost_per_* path was
  // dropped after every active package migrated to per-tool cost components
  // (verified via SQL before the cleanup deploy). The pricing engine now
  // unconditionally reads costComponents — if a package has zero components,
  // toolingCost is 0 (correct: no stack = no cost). The four stack_cost_per_*
  // pricing_settings rows and the packages.use_cost_components column were
  // dropped in the same deploy via v3.5.57_drop_legacy_stack_settings.sql.
  const r = calcToolingFromComponents(costComponents || [], inputs);
  const toolingCost  = r.total;
  const toolingTools = r.tools;

  const hrsUsers   = inputs.users        * (parseFloat(pkg.hrs_user)   || 0);
  const hrsWs      = inputs.workstations * (parseFloat(pkg.hrs_ws)     || 0);
  const hrsServers = inputs.servers      * (parseFloat(pkg.hrs_server) || 0);
  const hrsLocs    = inputs.locations    * (parseFloat(pkg.hrs_location) || 0);
  const svcHrs = hrsUsers + hrsWs + hrsServers + hrsLocs;
  // v3.5.58: settings-driven burden rate via helper (fallback default updated
  // from 125 → 80 to match FerrumIT's actual blended cost; replaces the
  // inline `parseFloat(s.burdened_hourly_rate) || 125` pattern that was
  // duplicated across 13 sites).
  const burdenedRate = getBurdenedRate(s);
  const svcCost = svcHrs * burdenedRate;
  const laborComponents = {
    users:        { qty: inputs.users,        hrsPer: parseFloat(pkg.hrs_user)     || 0, hours: hrsUsers,   cost: hrsUsers   * burdenedRate },
    workstations: { qty: inputs.workstations, hrsPer: parseFloat(pkg.hrs_ws)       || 0, hours: hrsWs,      cost: hrsWs      * burdenedRate },
    servers:      { qty: inputs.servers,      hrsPer: parseFloat(pkg.hrs_server)   || 0, hours: hrsServers, cost: hrsServers * burdenedRate },
    locations:    { qty: inputs.locations,    hrsPer: parseFloat(pkg.hrs_location) || 0, hours: hrsLocs,    cost: hrsLocs    * burdenedRate },
  };

  // v3.5.58/v3.5.74: itsoCost included in total cost. Now reflects Option
  // B-prime semantics — itsoCost = senior-advisory hours × senior burdened
  // rate, so this contributes a real (cost-only) line to totalCost and
  // produces positive margin on the ITSO advisory line at quote level.
  const totalCost = toolingCost + svcCost + addonCost + includedItemsCost + itsoCost;
  const impliedGM = finalMRR > 0 ? 1 - totalCost / finalMRR : 0;

  // ── Onboarding ────────────────────────────────────────────────────────────
  const obMin = parseFloat(s.onboarding_min) || 500;
  const obCalc = inputs.users        * parseFloat(s.onboarding_per_user)
               + inputs.workstations * parseFloat(s.onboarding_per_ws)
               + inputs.servers      * parseFloat(s.onboarding_per_server)
               + inputs.locations    * parseFloat(s.onboarding_per_location)
               // v3.5.96.0: per-domain onboarding fee. Default $99 if the
               // pricing_settings.onboarding_per_domain row isn't present
               // yet (the SQL migration ships separately — code is safe to
               // deploy without the row). Legacy quotes without inputs.domains
               // default to 0 via the (... || 0) guard.
               + (parseInt(inputs.domains) || 0) * (parseFloat(s.onboarding_per_domain) || 99);
  const onboarding = Math.max(obCalc, obMin);

  // ── Package recommendation ────────────────────────────────────────────────
  let recommended = 'Business Essentials';
  // v3.5.58: execReporting input removed — Executive Reporting Required toggle
  // was retired alongside the flat-rate Strategic Advisory products. The
  // recommendation now relies on industry risk + complexity + scale alone.
  // v3.5.59: compliance dropdown expanded to 5 values (none / hipaa / soc2 /
  // pci / cmmc). PCI DSS and CMMC are the high-bar frameworks that warrant
  // Enterprise; HIPAA and SOC 2 land in Business Plus territory.
  const isHighCompliance = ['pci', 'cmmc', 'high'].includes(inputs.compliance);  // legacy 'high' kept for any remaining test quotes
  const hasAnyCompliance = inputs.compliance && inputs.compliance !== 'none';
  if (inputs.users >= 75 || inputs.requestedCoverage === '24x7' ||
      isHighCompliance || inputs.industryRisk === 'high' ||
      inputs.locations >= 3 || inputs.servers >= 5)
    recommended = 'Enterprise';
  else if (inputs.users >= 25 || inputs.requestedCoverage !== 'business_hours' ||
           hasAnyCompliance || (inputs.industryRisk !== 'low' && inputs.industryRisk !== 'none') ||
           inputs.cloudTenants >= 1 || inputs.vendors > 3)
    recommended = 'Business Plus';

  const opSubtotal = itSubtotal + addonRevenue; // retained for display compatibility

  return {
    // Managed IT breakdown
    wB, uB, sB, lB, tB, vB, eB, covU, itSubtotal,
    // v3.5.61: Log Storage & SIEM Uplift breakdown — quote pages use these to
    // render inline math on the line item ("5 dev × $5 — moderate"). xEp can
    // be fractional (workstations × 1.25 isn't always an integer); the quote
    // page handles formatting.
    xEp, epRate, epRatio, epTier,
    // Add-ons
    lineItems, addonRevenue,
    // Package includes (v3.5.31)
    // Package includes (v3.5.31, v3.5.33)
    includedLineItems, includedItemsCost, excludedIncludeIds,
    includeSwaps: includeSwaps || {},
    // Summary
    opSubtotal, compMult, riskAdjMRR, floor,
    discount, discRate, finalMRR,
    discountableSubtotal, // v3.5.36: exposed for multi-term explainer UI
    discountedLabor, protectedAddonRevenue, discountableAddonRevenue,
    commission, commissionRate, commissionBase, netAfterCommission,
    // Cost model
    toolingCost, svcHrs, svcCost, addonCost, totalCost, impliedGM,
    // v3.5.39: laborComponents kept (per-driver breakdown for UI transparency).
    // v3.5.57: toolingComponents and toolingPath removed — no longer applicable
    // now that the legacy aggregate stack_cost_per_* path has been deleted.
    laborComponents,
    // v3.5.41: per-tool breakdown — sole remaining tooling path post-v3.5.57
    toolingTools,
    // v3.5.58: ITSO Advisory line — derived from Industry Risk tier. itsoMRR
    // is the customer-facing line item; itsoHours/itsoCost are the senior-
    // staff allocation that flows into totalCost. Consumers (cost panels,
    // Deal Summary, SPT, signature docs) read these fields to render the
    // line. itsoLabel is null when uplift rate is 0 (no line displays).
    itsoMRR, itsoLabel, itsoUpliftRate, itsoBaseMRR, itsoHours, itsoCost,
    // Onboarding
    onboarding, obCalc, onboardingIsMinimum: obCalc < obMin,
    // Meta
    recommended, mktMult
  };
}

function getQtyForDriver(driver, inputs, product) {
  switch (driver) {
    case 'user':          return inputs.users;
    case 'mailbox':       return inputs.users + (inputs.sharedMailboxes || 0);
    case 'workstation':   return inputs.workstations;
    case 'server':        return inputs.servers;
    case 'location':      return inputs.locations;
    case 'flat':          return 1;
    case 'mobile_device': return inputs.mobileDevices || 0;
    case 'mixed':         return inputs.workstations;
    // v3.5.96.0: 'domain' added for Managed IT / Bundle products that bill
    // per-domain (e.g. domain monitoring, DNS, certificate renewal). Reads
    // inputs.domains. For MultiSite, MultiSiteQuotePage sums per-location
    // domains before the addon products useMemo runs and exposes the total
    // there directly — see the addon products switch in MultiSiteQuotePage
    // for the 'domain' branch (similar to the existing 'user' / 'workstation'
    // branches that aggregate across locations).
    case 'domain':        return inputs.domains || 0;
    // 'manual' lets reps enter the qty themselves on the quote (e.g. M365 license counts
    // that don't track 1:1 with users or workstations). Stored at inputs.manualQuantities[productId].
    case 'manual':        return parseInt(inputs.manualQuantities?.[product?.id] || 0);
    default:              return 0;
  }
}

function getSellQty(product, inputs) {
  return getQtyForDriver(product.qty_driver, inputs, product);
}

function getCostQty(product, inputs) {
  // cost_qty_driver overrides qty_driver for cost calculation
  // NULL means same as sell driver
  const driver = product.cost_qty_driver || product.qty_driver;
  return getQtyForDriver(driver, inputs, product);
}

// ─── FORMAT HELPERS ──────────────────────────────────────────────────────────
export const fmt$ = (v, d = 2) => v == null ? '—'
  : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD',
      minimumFractionDigits: d, maximumFractionDigits: d }).format(v);
export const fmt$0 = v => fmt$(v, 0);
export const fmtPct = v => v == null ? '—' : (v * 100).toFixed(1) + '%';
export const gmColor = g => g >= 0.45 ? '#166534' : g >= 0.30 ? '#92400e' : '#991b1b';
export const gmBg    = g => g >= 0.45 ? '#dcfce7' : g >= 0.30 ? '#fef3c7' : '#fee2e2';

// ─── Multi-Site Quote Functions ───────────────────────────────────────────────

// Calculate MRR for a single location
// `packageIncludes` (added v3.5.31): bundled product rows (same shape as for
//   calcQuote). When provided, cost contribution is computed per-location
//   using location.users / location.workstations / etc. as the qty driver.
//   Sell side stays at $0 (the package fee covers delivery).
// `excludedIncludes` (added v3.5.31): array of include IDs the rep removed
//   for THIS location. Multi-Site stores a separate excludedIncludes per
//   location so reps can adjust which bundled products apply per site.
// `includeSwaps` (added v3.5.33): map of include_id -> substitute product_id.
//   Substitutes price as paid add-ons at full sell + full cost, both
//   contributing to the location's MRR and per-location cost contribution.
// `products` (added v3.5.33): products catalog (needed to look up substitutes).
export function calcLocationMRR({ location, pkg, marketMultiplier, settings, packageIncludes, excludedIncludes, includeSwaps, products, costComponents }) {
  if (!pkg || !location) return null;
  const s = settings;
  const mktMult = parseFloat(marketMultiplier) || 1;
  const isStandard = location.type !== 'restricted';

  const users        = parseInt(location.users)        || 0;
  const workstations = parseInt(location.workstations) || 0;
  const servers      = parseInt(location.servers)      || 0;
  const endpoints    = parseInt(location.endpoints)    || 0;
  const locationFee  = isStandard ? (parseFloat(pkg.location_rate) || 0) : 0;

  // Log Storage & SIEM Uplift (was "Endpoint density uplift") —
  // bracket the rate at ratio = 1.75. v3.5.61: explicit epTier so MultiSite
  // breakdown can render inline math the same way the main calc does.
  const epRatio = workstations > 0 ? endpoints / workstations : 0;
  const xEp     = Math.max(endpoints - workstations * 1.25, 0);
  const epTier  = epRatio <= 1.75 ? 'moderate' : 'high';
  const epRate  = epTier === 'moderate'
    ? parseFloat(s.ep_uplift_moderate) || 0
    : parseFloat(s.ep_uplift_high)     || 0;
  const eB = xEp * epRate;

  const base = users * pkg.user_rate
             + workstations * pkg.ws_rate
             + servers * pkg.server_rate
             + locationFee
             + eB;

  // ── Package Includes — per-location cost contribution (v3.5.31) ──────────
  // Build a synthetic inputs object so we can reuse the same qty-driver
  // logic as calcQuote. Only fields used by getQtyForDriver are needed.
  const includeInputs = {
    users, workstations, servers,
    locations:       1,
    sharedMailboxes: 0,
    mobileDevices:   parseInt(location.mobileDevices) || 0,
    endpoints,
  };
  const includedLineItems = [];
  let includedItemsCost = 0;
  const excludedSet = new Set(excludedIncludes || []);
  for (const inc of (packageIncludes || [])) {
    if (excludedSet.has(inc.id)) continue;
    const cqDriver = inc.cost_qty_driver || inc.qty_driver;
    const product  = { id: inc.product_id, qty_driver: inc.qty_driver, cost_qty_driver: cqDriver };
    const sellQty  = getSellQty(product, includeInputs);
    const costQty  = getCostQty(product, includeInputs);
    const cost     = costQty * (Number(inc.cost_price) || 0);
    includedItemsCost += cost;
    includedLineItems.push({
      include_id:      inc.id,
      product_id:      inc.product_id,
      product_name:    inc.product_name,
      is_mandatory:    !!inc.is_mandatory,
      qty_driver:      inc.qty_driver,
      cost_qty_driver: cqDriver,
      qty:             sellQty,
      cost_qty:        costQty,
      sell_price:      0,
      cost_price:      Number(inc.cost_price) || 0,
      revenue:         0,
      cost,
      sort_order:      inc.sort_order ?? 100,
    });
  }
  includedLineItems.sort((a, b) => a.sort_order - b.sort_order);

  // ── Swap substitutes — per-location revenue + cost contribution (v3.5.33) ─
  // For each swap mapping, look up the substitute product in the catalog and
  // compute its qty/sell/cost using the same per-location synthetic inputs.
  // Substitutes participate in the location's MRR (sell side) and cost (COGS).
  // Only processed if the include is also in excludedSet — otherwise the
  // include is still active and the swap is meaningless.
  const swapLineItems = [];
  let swapRevenue = 0;
  let swapCost    = 0;
  if (includeSwaps && typeof includeSwaps === 'object' && Array.isArray(products)) {
    for (const [includeId, subProductId] of Object.entries(includeSwaps)) {
      if (!excludedSet.has(includeId)) continue;
      const sub = products.find(pr => pr.id === subProductId);
      if (!sub) continue;
      const sellQty  = getSellQty(sub, includeInputs);
      const costQty  = getCostQty(sub, includeInputs);
      const revenue  = sellQty * (Number(sub.sell_price) || 0);
      const cost     = costQty * (Number(sub.cost_price) || 0);
      swapRevenue += revenue;
      swapCost    += cost;
      swapLineItems.push({
        product_id:           sub.id,
        product_name:         sub.name,
        category:             sub.category,
        qty_driver:           sub.qty_driver,
        cost_qty_driver:      sub.cost_qty_driver || null,
        qty:                  sellQty,
        cost_qty:             costQty,
        sell_price:           sub.sell_price,
        cost_price:           sub.cost_price,
        revenue,
        cost,
        swap_from_include_id: includeId,
      });
    }
  }

  // Final MRR = base package math + swap substitutes' sell side, all market-adjusted
  const mrr = (base + swapRevenue) * mktMult;

  // ── Tooling + Labor cost (v3.5.39 / v3.5.41) ─────────────────────────────
  // v3.5.41: branched tooling cost computation per package config.
  // Note: cloud-tenants is NOT a per-location concept in MultiSite, so the
  // legacy aggregate path here only computes ws/users/servers tooling. If
  // a package's components reference cloud_tenants, those rows will resolve
  // to qty=0 per location (since location.cloudTenants doesn't exist) and
  // contribute nothing to per-location cost. That's acceptable — MultiSite
  // doesn't model cloud_tenants today.
  //
  // Synthetic inputs object (matching calcToolingFromComponents driver names)
  // built from this location's data. mobile_devices is per-location.
  const componentInputs = {
    workstations,
    users,
    servers,
    locations:     1,
    cloudTenants:  0,  // not modeled per-location in MultiSite
    endpoints,
    mobileDevices: parseInt(location.mobileDevices) || 0,
  };
  // v3.5.57: components-only (see calcQuote comment for the full rationale).
  const r = calcToolingFromComponents(costComponents || [], componentInputs);
  const toolingCost  = r.total;
  const toolingTools = r.tools;

  // Labor: per-location service hours × burdened rate. Each location contributes
  // hrs_location once (it IS one location) plus driver-scaled hours.
  const hrsUsers   = users        * (parseFloat(pkg.hrs_user)     || 0);
  const hrsWs      = workstations * (parseFloat(pkg.hrs_ws)       || 0);
  const hrsServers = servers      * (parseFloat(pkg.hrs_server)   || 0);
  const hrsLoc     = 1            * (parseFloat(pkg.hrs_location) || 0);
  const svcHrs = hrsUsers + hrsWs + hrsServers + hrsLoc;
  const burdenedRate = parseFloat(s.burdened_hourly_rate) || 125;
  const svcCost = svcHrs * burdenedRate;
  const laborComponents = {
    users:        { qty: users,        hrsPer: parseFloat(pkg.hrs_user)     || 0, hours: hrsUsers,   cost: hrsUsers   * burdenedRate },
    workstations: { qty: workstations, hrsPer: parseFloat(pkg.hrs_ws)       || 0, hours: hrsWs,      cost: hrsWs      * burdenedRate },
    servers:      { qty: servers,      hrsPer: parseFloat(pkg.hrs_server)   || 0, hours: hrsServers, cost: hrsServers * burdenedRate },
    locations:    { qty: 1,            hrsPer: parseFloat(pkg.hrs_location) || 0, hours: hrsLoc,     cost: hrsLoc     * burdenedRate },
  };

  return {
    mrr,
    base,
    mktMult,
    isRestricted: !isStandard,
    breakdown: {
      users:         users * pkg.user_rate * mktMult,
      workstations:  workstations * pkg.ws_rate * mktMult,
      servers:       servers * pkg.server_rate * mktMult,
      locationFee:   locationFee * mktMult,
      endpointUplift: eB * mktMult,
      // v3.5.61: Log Storage & SIEM Uplift breakdown for the inline label.
      // Note: epRate is the per-device rate from settings (pre-market). The
      // dollar value on the line (endpointUplift) is post-market via mktMult,
      // matching the convention used by users/workstations/servers above.
      epXEp:    xEp,
      epRate,
      epRatio,
      epTier,
      swapRevenue:   swapRevenue * mktMult,
    },
    // Package includes
    includedLineItems,
    includedItemsCost,
    // Swap substitutes (v3.5.33)
    swapLineItems,
    swapRevenue,
    swapCost,
    // Cost basis (v3.5.39 — was previously missing entirely from MultiSite quotes)
    toolingCost,
    svcHrs,
    svcCost,
    laborComponents,
    // v3.5.41: per-tool breakdown — sole tooling path post-v3.5.57
    toolingTools,
  };
}

// Get multi-location discount rate from settings
export function getMultiSiteDiscount(locationCount, settings) {
  const s = settings || {};
  if (locationCount >= 20) return parseFloat(s.multisite_disc_20plus) || 0.10;
  if (locationCount >= 10) return parseFloat(s.multisite_disc_10_19)  || 0.08;
  if (locationCount >= 5)  return parseFloat(s.multisite_disc_5_9)    || 0.05;
  if (locationCount >= 2)  return parseFloat(s.multisite_disc_2_4)    || 0.03;
  return 0;
}

// v3.5.95.0 — Get GM floor target for the margin-guarded discount engine.
// Defaults to 0.40 (40%) matching the "GM ≥ 40%" target visible in the
// pre-deploy "GM 48.9% — locked at target (40%)" message on quote
// 8f95586c-2730-4970-98e3-72a59be13d9c. Admin-editable via pricing_settings
// row `multisite_gm_floor` (decimal: 0.40 = 40%). Out-of-range values
// (negative, > 1, NaN) fall back to default.
export function getMultiSiteGmFloor(settings) {
  const s = settings || {};
  const v = parseFloat(s.multisite_gm_floor);
  return Number.isFinite(v) && v >= 0 && v <= 1 ? v : 0.40;
}

// v3.5.95.0 — Margin-guarded multi-site discount solver. Phase 1 anchored
// design option B (Shaun, May 12 2026) of the §10f #4 discount-engine
// redesign. Replaces the prior tier-lookup-then-unconditionally-apply
// behavior with a GM-floor-aware engine that emits the maximum discount
// rate keeping GM at or above the configured floor.
//
// ── DESIGN GOAL ────────────────────────────────────────────────────────────
// Pre-deploy: Multi-Site quotes applied the tier-lookup rate
// (`getMultiSiteDiscount`) unconditionally — 8% on a 10-location deal even
// when that 8% pushed effective GM below target. Margin leak on every
// larger-location deal that didn't have headroom. Customer-facing proposal
// rendered the headline discount but the actual margin damage was invisible
// until a rep manually checked the GM indicator.
//
// Post-deploy: the engine returns three values:
//   • rateConfigured — what the tier table says (unchanged)
//   • rateApplied    — the largest rate ≤ rateConfigured that keeps
//                      GM ≥ floor (default 40%, admin-settable)
//   • capped         — true iff rateApplied < rateConfigured (i.e. the
//                      floor actively reduced the rate — used for the
//                      rep-UX "X% configured · Y% applied (GM floor)"
//                      display states at MultiSiteQuotePage)
//
// ── ALGEBRAIC DERIVATION ──────────────────────────────────────────────────
// Inputs the engine produces, written in terms of r (the rate to solve):
//   L = totalLocationMRR (pre-discount labor MRR)
//   I = itsoGross = L × itsoUpliftRate (pre-discount ITSO MRR)
//   t = termDiscRate (fixed for the quote)
//   A = addonRevenue (outside discount chain)
//   F = flexBlockMRR (outside discount chain)
//   C_fixed = totalToolingCost + totalSvcCost + addonCost + flexLaborCost
//             + totalIncludesCost + totalSwapCost   (all r-independent)
//   k = seniorBurden / itsoBillable (cost-per-dollar-of-ITSO-MRR scalar;
//       defaults to 110/200 = 0.55)
//
// MultiSiteQuotePage line 350-357 confirms ITSO cost is r-dependent:
//   itsoMRR(r)  = I × (1−r)(1−t)
//   itsoHours   = itsoMRR(r) / itsoBillable
//   itsoCost(r) = itsoHours × seniorBurden
//               = I × (1−r)(1−t) × k
//
// With u = (1−r)(1−t) (substitution; monotone in r):
//   effectiveMRR(r)  = (L + I) × u + A + F
//   effectiveCost(r) = C_fixed + I × k × u
//   GM(r) = 1 − effectiveCost(r) / effectiveMRR(r)
//
// Solving GM(r) = G for the boundary u:
//   C_fixed + I × k × u = (1−G) × ((L+I) × u + A + F)
//   u × [I × k − (1−G)(L+I)] = (1−G)(A + F) − C_fixed
//   u = [(1−G)(A + F) − C_fixed] / [I × k − (1−G)(L+I)]
//
// Then r = 1 − u/(1−t). Clamp to [0, rateConfigured].
//
// ── EDGE CASES (all handled below) ────────────────────────────────────────
// (1) rateConfigured = 0 (e.g. 1-location quote): trivial, return zeros.
// (2) effectiveMRR(0) ≤ epsilon: degenerate (deal with no MRR); return
//     (rateConfigured, 0, true).
// (3) Underlying deal already below floor at r=0: solver math would return
//     negative r; we detect this earlier with a direct GM(0) probe.
// (4) Configured rate already meets floor: return configured, no capping.
// (5) Denominator near zero (degenerate algebra): return (rateConfigured,
//     0, true) as a safe conservative fallback.
// (6) Term discount = 100% (t ≥ 1): degenerate; return (rateConfigured,
//     0, true).
//
// ── ROUNDING NOTE ─────────────────────────────────────────────────────────
// MultiSiteQuotePage lines 350/352/357 round to cents (Math.round(x*100)/
// 100). The solver works on exact algebra; the actual GM after the engine
// runs may differ from the solver's predicted GM by sub-cent (typically
// <$0.01 of cost on a multi-thousand-dollar MRR — algebraically irrelevant).
// We quantize rateApplied to 4 decimal places to avoid floating-point
// artifacts at the boundary that would cause `capped` to flicker between
// true/false on identical inputs across renders.
//
// Returns: { rateConfigured, rateApplied, capped }
export function applyMultiSiteDiscountWithFloor({
  rateConfigured,
  totalLocationMRR,
  itsoGross,
  termDiscRate,
  addonRevenue,
  flexBlockMRR,
  fixedCost,
  itsoBillable,
  seniorBurden,
  gmFloor,
}) {
  // Edge case (1): no configured discount, nothing to solve
  if (!Number.isFinite(rateConfigured) || rateConfigured <= 0) {
    return { rateConfigured: 0, rateApplied: 0, capped: false };
  }

  const L  = Number(totalLocationMRR) || 0;
  const I  = Number(itsoGross)        || 0;
  const t  = Number(termDiscRate)     || 0;
  const A  = Number(addonRevenue)     || 0;
  const Fm = Number(flexBlockMRR)     || 0;
  const Cf = Number(fixedCost)        || 0;
  const ib = Number(itsoBillable)     || 200;
  const sb = Number(seniorBurden)     || 110;
  const G  = Number.isFinite(gmFloor) && gmFloor >= 0 && gmFloor <= 1 ? gmFloor : 0.40;
  const k  = ib > 0 ? sb / ib : 0;

  // GM(r) probe — used for boundary tests
  const gmAt = (r) => {
    const u   = (1 - r) * (1 - t);
    const mrr = (L + I) * u + A + Fm;
    if (mrr <= 0.01) return -Infinity;  // edge case (2)
    const cost = Cf + I * k * u;
    return 1 - cost / mrr;
  };

  // Edge case (4): configured rate already satisfies floor → no capping
  if (gmAt(rateConfigured) >= G) {
    return { rateConfigured, rateApplied: rateConfigured, capped: false };
  }

  // Edge case (3): even r=0 can't reach floor → engine emits 0
  if (gmAt(0) < G) {
    return { rateConfigured, rateApplied: 0, capped: true };
  }

  // Edge case (6): pathological term discount
  if (t >= 1 - 1e-9) {
    return { rateConfigured, rateApplied: 0, capped: true };
  }

  // Solve for the boundary u
  const numerator   = (1 - G) * (A + Fm) - Cf;
  const denominator = I * k - (1 - G) * (L + I);

  // Edge case (5): degenerate denominator
  if (Math.abs(denominator) < 1e-9) {
    return { rateConfigured, rateApplied: 0, capped: true };
  }

  const u = numerator / denominator;
  const r = 1 - u / (1 - t);

  // Clamp to [0, rateConfigured] and quantize to 4 decimal places (.01% precision)
  const clamped = Math.max(0, Math.min(rateConfigured, r));
  const rateApplied = Math.round(clamped * 10000) / 10000;
  const capped = rateApplied < rateConfigured - 1e-6;

  return { rateConfigured, rateApplied, capped };
}

// Create a blank location object
export function createLocation(overrides = {}) {
  return {
    id:            'loc_' + Date.now() + '_' + Math.random().toString(36).slice(2,7),
    name:          '',
    address:       '',
    city:          '',
    state:         '',
    zip:           '',
    type:          'standard',
    users:         0,
    workstations:  0,
    servers:       0,
    endpoints:     0,
    mobileDevices: 0,
    // v3.5.96.0: domains per-location. Use case: franchises where the
    // franchisor owns/manages location-specific domains (e.g.
    // coffeeshopelgin.com, coffeeshopseattle.com) and bills the cost
    // back to each franchisee. Existing locations saved before v3.5.96.0
    // load with domains undefined; per-location aggregations in
    // MultiSiteQuotePage default these to 0 via parseInt(l.domains) || 0.
    domains:       0,
    ...overrides,
  };
}
